var styleDataHash = '6f371d71';  
export const injectCss = (() => {
  var css = `._0jj6Y{box-sizing:border-box;height:29px;margin:0 auto;max-width:100%;padding-top:14px;width:100%}.QdOZ3{padding-top:11px}._2lsaE{display:block;stroke:currentColor;stroke-width:1;shape-rendering:crispEdges}.LKdCn,.Prn08,.QGCO2,.sYCoG{height:100%}.Prn08{stroke-dasharray:4 4}.LKdCn{stroke-dasharray:1 5}.r3uHb{width:10%}.IIK9N{width:40%}.wv3A6{width:100%}.RtIBk{margin-right:auto}.we2bw{margin:0 auto}.A3qra{margin-left:auto}.IhffT{height:100%}.IhffT .LIWUB{height:1px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





